export * from "./favorites-tabs.component";
